export default function () {
  return {
    isVisible: false,
    hl: '',
    message: '',
  };
}
